function fontRem(vue) {
    ; (function (win, doc) {
        var docEl = doc.documentElement;

        function setFontSize() {
            var clientWidth = document.documentElement.clientWidth;
            if (!clientWidth) return;
            let rem = 20 * (clientWidth / 375)

            //原本对于html的字号设置 我这里用的是750的标准 ，640的也是同理
            if (clientWidth > 700) {
                rem = 20
            }

            docEl.style.fontSize = rem + 'px';

            vue.$store.commit("setHeight", window.innerHeight);

            if (window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize) {
                var size = window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.split('p')[0];
                //这里再取出当前html的font-size，和你想附的值进行比较，
                //这里为什么不直接用size< 原因是正常机型的size也不一定等于你想附的值，尝试了很多机型，除了问题机型外，一般差距很小，另一半完全相等;      
                //为什么不直接*1.25 也不解释了 最终比例不一定是1.25                
                if (size * 1.2 < rem) {
                    //如果当前html的font-size 的1.2倍仍然小于 之前想设置的值，就说明是问题机型，给之前想附的值乘1.25倍，这样他会被系统再次除1.25得到的才是我们想附的值
                    docEl.style.fontSize = rem * 1.25 + 'px';
                }
            }
        };
        setFontSize();
        win.addEventListener('resize', function () {
            setFontSize();
        }, false);
    })(window, document);
};
(function () {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    }
    function handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        });
    }
})();

export function rem(vue) {
    // if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    //     fontRem(vue);
    // }
    fontRem(vue);
}



// WEBPACK FOOTER //
// ./src/public/rem.js